import service from '@/services/produccion/production'

const productionSet = {
  emisor: { id: '' },
  order: '',
  sequence: 0,
  status: 'COMPLETADO',
  location: '',
  machine: [],
  user: {},
  startDate: null,
  endDate: null,
  item: [],
  expirationDate: null,
}

const getDefaultState = () => ({
  productionSet,
  list: [],
  production: [],
  pageInfo: {},
  currentRow: null,
  totalRegistros: 0,
  lastStatus: ''
})

export const state = () => getDefaultState()

export const mutations = {
  RESET_STATE: state => Object.assign(state, getDefaultState()),
  RESET: state => {
    state.productionSet = {
      emisor: { id: '' },
      order: '',
      sequence: 0,
      status: 'COMPLETADO',
      location: '',
      machine: [],
      user: {},
      startDate: null,
      endDate: null,
      item: []
    }
  },
  SET_ROW: (state, row) => (state.currentRow = row),
  SET_LIST: (state, obj) => {
    state.list = [...new Set([...state.list.map(JSON.stringify), ...obj.feed.map(JSON.stringify)])].map(JSON.parse)
    state.pageInfo = obj.pageInfo
  },
  UPDATE_LIST: (state, obj) => {
    const nObj = state.list.find(e => e._id === obj._id)
    if (!nObj) state.list = [obj, ...state.list]
    else Object.keys(nObj).forEach(i => (nObj[i] = obj[i]))

    state.saved = true
  },
  SET_LIST_BY_DATE: (state, obj) => {
    state.list = obj.feed
    state.pageInfo = obj.pageInfo
  },
  SET: (state, obj) => {
    state.productionSet = obj
  },
  SET_LAST_STATUS: (state, obj) => {
    state.lastStatus = obj
  }
}

export const actions = {
  resetList: ({ state }) => {
    state.list = []
    state.pageInfo = {}
  },
  readTotal: async ({ state, rootGetters }) =>
    service.readTotal(await rootGetters['facturacion/emisorStore/get_Id']).then(response => {
      state.totalRegistros = response
    }),
  readAllByEmisor: async ({ commit, state, dispatch, rootGetters }, { restart = false, limit = 10, filter = null }) => {
    if (restart) await dispatch('resetList')

    // manufactura, reventa, consumible: tipoProducto === '02' - '03' - '04'
    return service.readAllByEmisor(rootGetters['facturacion/emisorStore/get_Id'], state.pageInfo.nextPageCursor, limit, filter).then(response => {
      console.log('Produccion from server 🤖')

      return commit('SET_LIST', response)
    })
  },
  readBySearchString: async ({ state, rootGetters }, { searchString }) =>
    service.readBySearchString(rootGetters['facturacion/emisorStore/get_Id'], searchString),

  readByDateRange: async ({ commit, dispatch, rootGetters }, { inicio, final }) => {
    await dispatch('resetList')

    return service.readByDateRange(rootGetters['facturacion/emisorStore/get_Id'], inicio, final).then(result => {
      return commit('SET_LIST_BY_DATE', result)
    })
  },

  create: async ({ commit, rootGetters }, input) => {
    if (input.sequence === 0) delete input.sequence

    return service
      .create({
        ...input,
        item: input.item.map(i => {
          return { ...i, quantity: Number(i.quantity) }
        }),
        emisor: {
          _id: await rootGetters['facturacion/emisorStore/get_Id']
        }
      })
      .then(result => {
        commit('UPDATE_LIST', {
          ...input,
          ...result
        })

        return result
      })
  },
  readById: async ({ commit }, { _id }) =>
    service.readById(_id).then(response => {
      commit('SET', response)
      return response
    })
}
